import React from 'react';

import { Button, EditableText, Switch } from '../../../../components';
import { trashIcon } from '../rule-utils';
import type { SwitchChangeEventHandler } from 'antd/es/switch';

interface DefaultRuleHeaderProps {
	name: string;
	className?: string;
	switchChecked?: boolean;
	toggleSwitch?: SwitchChangeEventHandler;
	disabled?: boolean;
	inactiveText?: string;
	onNameChange?: (name: string) => void;
	onRemove?: (e) => void;
}

export const RuleHeader = ({
	name,
	onNameChange,
	className,
	onRemove,
	toggleSwitch,
	switchChecked,
	disabled,
	inactiveText = 'Inactive'
}: DefaultRuleHeaderProps) => (
	<div className={className}>
		{onNameChange && !disabled ? <EditableText value={name} onValueChange={onNameChange} /> : <div>{name}</div>}
		{toggleSwitch && !switchChecked && (
			<div className="inactive-badge">
				<span>{inactiveText}</span>
			</div>
		)}
		<div className="actions">
			{onRemove ? (
				<Button
					shape="circle"
					className="remove-button"
					icon={trashIcon}
					onClick={onRemove}
					disabled={disabled}
				/>
			) : null}
			{toggleSwitch ? (
				<Switch
					disabled={disabled}
					checked={switchChecked}
					onChange={toggleSwitch}
					className="enabled-switch"
				/>
			) : null}
		</div>
	</div>
);
